// src/services/supabase.js
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Não quebrar a aplicação se as envs não estiverem definidas
if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    "[Supabase] REACT_APP_SUPABASE_URL ou REACT_APP_SUPABASE_ANON_KEY não foram definidos. O cliente Supabase será null."
  );
}

const supabase =
  supabaseUrl && supabaseAnonKey
    ? createClient(supabaseUrl, supabaseAnonKey)
    : null;

export default supabase;
